// src/pages/OpenRedirect.js
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "./supabaseClient";

export default function OpenRedirect() {
    const { id } = useParams();
    const [fallbackVisible, setFallbackVisible] = useState(false);

    const fetchCampaign = async (campaign) => {
        const { data, error } = await supabase
            .from("links")
            .select("*")
            .eq("campaign_name", campaign)
            .single();

        if (error) return;


        let product_id = ""
        let variant_id = ""

        data.data?.map((item, idx) => {
            if (item.key === "product_id") {
                product_id = item.value;
            }

            if (item.key === "variant_id") {
                variant_id = item.value;
            }
            console.log("item", item);
        });
        redirectToPage(product_id, variant_id);

        // return {
        //     product_id,
        //     variant_id
        // }
    }

    function encodeData(data) {
    const dataWithKey = `${'Bharatsey123'}:${data}`;
    return btoa(dataWithKey);
}


    const redirectToPage = (product_id, variant_id) => {
        const iosAppLink = `bharatsey://open/${product_id}/${variant_id}`;
        const androidAppLink = `bharatsey://open/${product_id}/${variant_id}`;
        const iosStoreLink = "https://apps.apple.com/app/idXXXXXXXX"; // replace with App Store link
        const androidStoreLink = "https://play.google.com/store/apps/details?id=com.bharatsey";
          const webLink = `https://bharatsey-development-website.web.app/product-detail/${id}/${encodeData(variant_id)}/${encodeData(product_id)}`;

        console.log("webLink", webLink);

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPhone|iPad|iPod/i.test(userAgent)) {
            // iOS
            window.location.href = iosAppLink;
            setTimeout(() => {
                setFallbackVisible(true);
                window.location.href = iosStoreLink;
            }, 1200);
        } else if (/android/i.test(userAgent)) {
            // Android
            window.location.href = androidAppLink;
            setTimeout(() => {
                setFallbackVisible(true);
                window.location.href = androidStoreLink;
            }, 1200);
        } else {
            // Web fallback
            window.location.href = webLink;
        }
    }

    useEffect(() => {
        fetchCampaign(id);
    }, [id]);

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Redirecting...</h2>
            <p style={styles.text}>Please wait while we open the app.</p>

            <div style={styles.loader}></div>

            {fallbackVisible && (
                <div style={styles.fallback}>
                    <p>If the app didn’t open, you can continue here:</p>
                    <a
                        href={`https://shop.bharatsey.com/${123}/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        Open in Browser
                    </a>
                </div>
            )}
        </div>
    );
}

// Simple inline styles (can replace with Tailwind/Material UI)
const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "20px",
    },
    heading: { fontSize: "24px", marginBottom: "10px" },
    text: { fontSize: "16px", marginBottom: "20px", color: "#555" },
    loader: {
        width: "40px",
        height: "40px",
        border: "4px solid #ddd",
        borderTop: "4px solid #007bff",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        marginBottom: "20px",
    },
    fallback: { marginTop: "20px" },
    link: {
        display: "inline-block",
        padding: "10px 20px",
        backgroundColor: "#007bff",
        color: "#fff",
        borderRadius: "6px",
        textDecoration: "none",
        marginTop: "10px",
    },
};
